import React from 'react';

const ShenShiTest: React.FC = () => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-pink-500 to-purple-600 flex items-center justify-center">
      <div className="bg-white rounded-lg shadow-xl p-8 max-w-md w-full mx-4">
        <div className="text-center">
          <h1 className="text-3xl font-bold text-gray-800 mb-4">🎮 审视页面测试</h1>
          <p className="text-gray-600 mb-6">
            如果您能看到这个页面，说明路由配置正常工作！
          </p>
          <div className="bg-green-100 border border-green-400 text-green-700 px-4 py-3 rounded mb-4">
            ✅ /shenshi 路由正常
          </div>
          <div className="text-sm text-gray-500">
            <p>访问路径：<code className="bg-gray-100 px-2 py-1 rounded">/#/shenshi</code></p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ShenShiTest;